import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "data-name": "Ikona Main Menu, Hamburger"
    }, [
      _createElementVNode("path", {
        d: "M1 1h16M1 7h16M1 13h16",
        "data-name": "Path 15429"
      })
    ], -1)
  ]))]))
}
export default { render: render }